/* eslint-disable import/prefer-default-export */
export function sleep(ms = 500) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}
